export const isOverlay = true;
export const SAFE_AREA_TOP_INSET = 0;
